import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoaderState {
  complete: boolean;
  progress: number; // 0 -> 1
  error?: string;
}

const initialState: LoaderState = {
  complete: false,
  progress: 0,
  error: undefined,
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    modelLoadProgress: (state, action: PayloadAction<number>) => {
      state.progress += action.payload;
      state.complete = state.progress >= 0.999;
    },
    modelLoadError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const {
  modelLoadProgress,
  modelLoadError,
} = loaderSlice.actions;

export const loaderReducer = loaderSlice.reducer;
